import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93ab5f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main mb-3" }
const _hoisted_2 = { class: "is-flex" }
const _hoisted_3 = { class: "is-flex switch-container" }
const _hoisted_4 = { class: "switch-centered" }
const _hoisted_5 = { class: "switch" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_8 = { class: "mr-1 switch-centered" }
const _hoisted_9 = { class: "ml-2 fas icon fa-triangle-exclamation" }
const _hoisted_10 = {
  key: 0,
  class: "mb-3 mt-1 info-bubble ml-4 pb-1"
}
const _hoisted_11 = { class: "warning" }
const _hoisted_12 = { class: "ml-2 fas icon fa-key" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: _ctx.useBiometry,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchUseBiometry && _ctx.switchUseBiometry(...args))),
              ref: "biometryCheckbox"
            }, null, 8, _hoisted_6),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$gettext("Use biometry for login")), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["justify-right", { missing: !_ctx.hasCredentialsAvailable }])
        }, [
          _createElementVNode("i", _hoisted_9, [
            _createVNode(_component_fa_icon, { icon: "fa-key" })
          ])
        ], 2)
      ])
    ]),
    (!_ctx.hasCredentialsAvailable && _ctx.useBiometry)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createElementVNode("i", _hoisted_12, [
              _createVNode(_component_fa_icon, { icon: "fa-triangle-exclamation" })
            ])
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Your credentials will be saved after your next login")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}